










import Vue from 'vue';

export default Vue.extend({
  props: {
    width: {
      type: Number,
      default: 25,
    },
    colour: {
      type: String,
      default: '#ffffff',
    },
  },
  computed: {
    height(): number {
      return this.width;
    },
    wrapperStyle(): object {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
      };
    },
    elementStyle(): object {
      return {
        height: `${this.height * 0.8}px`,
        width: `${this.width * 0.8}px`,
        margin: `${this.width * 0.1}px`,
        borderWidth: `${this.width * 0.1}px`,
        borderColor: `${this.colour} transparent transparent transparent`,
      };
    },
  },
});

